module.exports = __webpack_public_path__ + "img/suone_4.75891613.jpg";